export enum WidgetActivityFilters {
	toDo = 'To Do',
	inProgress = 'In Progress',
	todayProgress = 'Today Progress',
	noProgress = 'No Progress',
	forReview = 'For Review',
	completed = 'Completed',
}
